/**
 * Décalages (DEC) — convention partagée renderer ↔ backoffice ↔ backend.
 *
 * Deux variables distinctes sont exposées dans toutes les formules
 * (maîtresses du cache, placeholders globaux, règles d'affichage produit) :
 *
 *   DECi (install) — décalage dérivé du TYPE D'INSTALLATION choisi par le
 *     client à l'étape 3. Hardcodé ici, indépendant du produit :
 *       - 'sol'      → -10   (cache au sol : on retire 10 mm)
 *       - 'sol-mur'  → -10
 *       - 'mur'      →  10   (cache mural : on ajoute 10 mm)
 *       - 'mur-haut' →  10
 *     Fallback : 10 si type inconnu.
 *
 *   DECc (cache) — décalage spécifique au PRODUIT (champ Products.dec en
 *     base, configurable dans le BO sur la page d'édition produit). Peut
 *     être `null` si non configuré.
 *
 * Pour rétrocompat des formules existantes qui référencent `DEC`, on expose
 * également `DEC` comme alias strict de `DECi`. Les formules qui veulent
 * l'ancien comportement "smart" (productDec si défini sinon installDerived)
 * doivent désormais utiliser explicitement `DECc ?? DECi`.
 *
 * SYNC : usipanel-backoffice/lib/decHelpers.js (jumeau strict).
 */

export const DECi_BY_INSTALL = {
  sol: -10,
  'sol-mur': -10,
  mur: 10,
  'mur-haut': 10,
};

export const DECi_DEFAULT = 10;

/**
 * Calcule le triplet { DEC, DECi, DECc } à injecter dans le contexte
 * d'évaluation des formules.
 *
 * @param {string} installationType — l'une des valeurs de DECi_BY_INSTALL.
 * @param {number|null|undefined} productDec — `Products.dec` du produit
 *   sélectionné. `null` ou `undefined` si pas configuré.
 * @returns {{ DEC: number, DECi: number, DECc: number|null }}
 */
export function resolveDecValues(installationType, productDec) {
  const DECi = DECi_BY_INSTALL[installationType] ?? DECi_DEFAULT;
  const DECc =
    productDec === null || productDec === undefined ? null : Number(productDec);
  return { DEC: DECi, DECi, DECc };
}
